var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{staticClass:"table",attrs:{"columns":_vm.columns,"dataSource":_vm.data,"pagination":false,"bordered":""}})}
var staticRenderFns = []

export { render, staticRenderFns }